import apiClient from './apiClient';

// F903 interface matching backend model
export interface F903 {
  f903_01: string;  // 職等代號
  f903_11: string;  // 職等名稱
  f903_91: string;  // 建立者
  f903_92: string | null;  // 建立日期
  f903_93: string;  // 修改者
}

export interface ListResponse {
  data: F903[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

const BASE = '/api/job-grade';

const jobGradeApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (code: string): Promise<F903> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(code)}`);
    return res.data;
  },

  create: async (data: Partial<F903>): Promise<F903> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (code: string, data: Partial<F903>): Promise<F903> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  delete: async (code: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(code)}`);
  },
};

export default jobGradeApi;
